<hlm-dialog-surface size="md">
  <hlm-dialog-header>
    <div hlmDialogHeading>
      <h2 hlmDialogTitle class="font-display text-xl">Manual Invoice</h2>
    </div>
    <span class="ml-auto"></span>
    <button hlmDialogClose tabindex="-1" (click)="cancel()">
      <hlm-icon name="lucideX" size="1rem" />
    </button>
  </hlm-dialog-header>

  <section hlmDialogBody>
    <form [formGroup]="generateForm" (ngSubmit)="generateInvoice()" class="flex flex-col gap-4">
      <div class="grid grid-cols-1 gap-x-6 gap-y-4 md:grid-cols-2">
        <hlm-form-field>
          <label hlmLabel for="genBasicFeeFrom">Basic Fee From</label>
          <input
            id="genBasicFeeFrom"
            hlmInput
            type="date"
            formControlName="basicFeeFrom"
            [min]="data.minDateStr"
          />
        </hlm-form-field>

        <hlm-form-field>
          <label hlmLabel for="genBasicFeeUntil">Basic Fee Until</label>
          <input
            id="genBasicFeeUntil"
            hlmInput
            type="date"
            formControlName="basicFeeUntil"
            [min]="data.minDateStr"
          />
        </hlm-form-field>

        <hlm-form-field>
          <label hlmLabel for="genServiceFeeFrom">Service Fee From</label>
          <input
            id="genServiceFeeFrom"
            hlmInput
            type="date"
            formControlName="serviceFeeFrom"
            [min]="data.minDateStr"
          />
        </hlm-form-field>

        <hlm-form-field>
          <label hlmLabel for="genServiceFeeUntil">Service Fee Until</label>
          <input
            id="genServiceFeeUntil"
            hlmInput
            type="date"
            formControlName="serviceFeeUntil"
            [min]="data.minDateStr"
          />
        </hlm-form-field>
      </div>
    </form>
  </section>

  <footer hlmDialogFooter>
    <button type="button" hlmBtn variant="outline" (click)="clean()">Clean</button>
    <button
      type="button"
      hlmBtn
      variant="default"
      (click)="generateInvoice()"
      [disabled]="generateForm.invalid || generating()"
    >
      @if (generating()) {
        <hlm-spinner size="16" />
        Generating…
      } @else {
        <hlm-icon name="lucideReceipt" size="0.9rem" />
        Generate
      }
    </button>
  </footer>
</hlm-dialog-surface>
